import { FilterPill } from '../../components/ui';
import { QUALITY_LABELS } from '../../utils/quality-labels';

import { type QualityCounts, type QualityFilter } from './session-filters';

interface SessionQualityFiltersProps {
  counts: QualityCounts;
  total: number;
  value: QualityFilter;
  onChange: (value: QualityFilter) => void;
  showEmpty: boolean;
  onToggleEmpty: () => void;
  includePlayground: boolean;
  onTogglePlayground: () => void;
}

export const SessionQualityFilters = ({
  counts,
  total,
  value,
  onChange,
  showEmpty,
  onToggleEmpty,
  includePlayground,
  onTogglePlayground,
}: SessionQualityFiltersProps) => {
  const pills: { key: QualityFilter; label: string; count: number; tone: string }[] = [
    {
      key: 'all',
      label: 'Alla',
      count: total,
      tone: 'bg-slate-100 text-slate-700 border-slate-200',
    },
    {
      key: 'poor',
      label: QUALITY_LABELS.poor,
      count: counts.poor,
      tone: 'bg-red-50 text-red-800 border-red-200',
    },
    {
      key: 'degraded',
      label: QUALITY_LABELS.degraded,
      count: counts.degraded,
      tone: 'bg-amber-50 text-amber-800 border-amber-200',
    },
    {
      key: 'good',
      label: QUALITY_LABELS.good,
      count: counts.good,
      tone: 'bg-green-50 text-green-800 border-green-200',
    },
    {
      key: 'insufficient',
      label: QUALITY_LABELS.insufficient,
      count: counts.insufficient,
      tone: 'bg-sky-50 text-sky-800 border-sky-200',
    },
    {
      key: 'unanalyzed',
      label: QUALITY_LABELS.unanalyzed,
      count: counts.unanalyzed,
      tone: 'bg-slate-50 text-slate-600 border-slate-200',
    },
  ];

  return (
    <div className="flex flex-wrap items-center gap-2 text-xs">
      <span className="text-slate-500">Analyskvalitet:</span>

      {pills.map((pill) => (
        <FilterPill
          key={pill.key}
          active={value === pill.key}
          tone={pill.tone}
          onClick={() => onChange(pill.key)}
        >
          {pill.label}
          <span className="rounded-full bg-white/60 px-1.5 py-0 text-[10px] font-semibold text-slate-600">
            {pill.count}
          </span>
        </FilterPill>
      ))}

      <FilterPill
        active={showEmpty}
        tone="bg-slate-50 text-slate-600 border-slate-200"
        title="Sessioner där kunden öppnade chatten men aldrig skrev något"
        onClick={onToggleEmpty}
      >
        {showEmpty ? '☑' : '☐'} Visa tomma
      </FilterPill>

      <FilterPill
        active={includePlayground}
        tone="bg-violet-50 text-violet-700 border-violet-200"
        ring="ring-violet-400"
        title="Interna testsessioner från admin-playgrounden. Räknas aldrig i statistiken."
        onClick={onTogglePlayground}
      >
        {includePlayground ? '☑' : '☐'} Visa playground
      </FilterPill>
    </div>
  );
};
